import * as React from 'react'

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import { grey } from '@mui/material/colors';

import { ICONS } from "../../../../core/EditorConstants";

import { WithTranslation, withTranslation } from 'react-i18next';

const styles = {
  contentColor: {
    transform: 'scale(0.95)',
    transition: 'transform 200ms ease-out',
    textAlign: 'center' as React.CSSProperties['textAlign'],
    margin: '0 auto',
    '&:hover': {
      transform: 'scale(1.15)' as React.CSSProperties['transform'],
    }
  },
  buttonColorless: {
    boxShadow: 'none',
    background: 'linear-gradient(45deg,#ffffff 49%,#F44336 51%,#ffffff 52%)',
    zIndex: 2,
    width: 'auto',
    height: 'auto',
    padding: '0',
    '&:hover': {
      background: 'linear-gradient(45deg,#d5d5d5 49%,#F44336 51%,#d5d5d5 52%)',
      transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 100ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    }
  },
  labelIcon: {
    backgroundColor: 'transparent',
    borderRadius: '50%',
    transition: 'box-shadow 150ms ease-in-out, border 150ms ease-in-out',
  },
  sizeSmallIconButton: {
    fontSize: '40px',
    borderRadius: '50%',
  },
  sizeXSmallIconButton: {
    fontSize: '30px',
    borderRadius: '50%',
    }
};

interface Props {
  showInToolbar?: boolean,
  handleColorless: () => void,
  isColorLessSelected: boolean,
}

interface State {
}

type PropsWithStyles = Props & WithTranslation;

class ColorLessItem extends React.Component<PropsWithStyles, State>{

  constructor(props: PropsWithStyles) {
    super(props);
  }
  

  render() {
    

    const colorLessItemState = this.props.isColorLessSelected ? '#1eaae4' : grey[100]
    const borderColorLessState = `2px solid ${colorLessItemState}`
    const colorLessStyles = !this.props.showInToolbar ? styles.contentColor : {}

      return (
        <Grid item xs={2} key={'colorLessItem'}>
          <Box
            sx={colorLessStyles}
          >
            <IconButton
              size="small"
              style={{
                ...styles.buttonColorless,
                label: styles.labelIcon,
                sizeSmall: !this.props.showInToolbar ? styles.sizeSmallIconButton : styles.sizeXSmallIconButton

              }}
              onClick={() => { this.props.handleColorless() }}
            >
              <SvgIcon
                style={{
                  ...styles.sizeSmallIconButton,
                  border: borderColorLessState,
                  color: grey[500]
                }}
              >
                <path d={ICONS.COLORLESS} />
              </SvgIcon>
            </IconButton>
          </Box>
        </Grid>
      )

  }

}

export default withTranslation("leftbar")(ColorLessItem);

